<template>
	<div class="pt-2">
		<CommonFlame :title="'担当製品一覧'">
			<v-row no-gutters justify="end">
				<v-col cols="12" sm="6" md="4" lg="3">
					<v-select
						label="担当者"
						:items="users"
						v-model="user_id"
						class="mt-4"
						item-text="full_name"
						item-value="id"
						outlined
						dense
						hide-details
						@change="setUserId"
						no-data-text="担当者が存在しません"
					/>
				</v-col>
			</v-row>
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="order_individual_infos"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="担当製品はありません。"
				>
					<template v-slot:item="{ item }">
						<tr class="no-click">
							<td>{{ processStatus(item) }}</td>
							<td>{{ item.ordered_product.product_number }}</td>
							<td>{{ item.sub_number }}</td>
							<td>{{ common.productNameWithSubName(item.ordered_product) }}</td>
							<td>{{ item.quantity }}</td>
							<td>
								{{
									item.delivery_info
										? common.formatDate(item.delivery_info.planned_shipping_date)
										: "未定"
								}}
							</td>
							<td>
								{{
									common.formatDateWithPlan(
										item,
										"start_date",
										"planned_start_date",
										"start_time",
										"planned_start_time"
									)
								}}
							</td>
							<td class="pa-1 text-center">
								<v-btn color="secondary" @click="openSelectDialog(item)">開始 / 再開</v-btn>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</CommonFlame>
		<SelectCheckSheetDialog
			:dialog.sync="dialog"
			:checkSheets="check_sheets"
			@open-page="openOrderIndividualInfoPage"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import SelectCheckSheetDialog from "./components/SelectCheckSheetDialog.vue"

export default {
	components: {
		CommonFlame,
		SelectCheckSheetDialog,
	},
	data() {
		return {
			users: [],
			user_id: null,
			dialog: false,
			order_individual_infos: [],
			check_sheets: [],
			headers: [
				{
					text: "工程",
					value: "process_status",
					width: "100px",
				},
				{
					text: "製造番号",
					value: "product_number",
					width: "150px",
				},
				{
					text: "枝番号",
					value: "sub_number",
					width: "80px",
				},
				{
					text: "製品名",
					value: "product_name",
					width: "200px",
				},
				{
					text: "数量",
					value: "quantity",
					width: "50px",
				},
				{
					text: "出荷予定日",
					value: "planned_shipping_date",
					width: "150px",
				},
				{
					text: "着手日",
					value: "start_date",
					width: "150px",
				},
				{
					text: "",
					value: "",
					width: "100px",
				},
			],
			common,
		}
	},
	mounted() {
		this.user_id = this.$route.query?.id
		this.fetchOrderIndividualInfos(true)
	},
	methods: {
		fetchOrderIndividualInfos(first_visit) {
			const headers = authenticate.setHeader()
			const params = { user_id: this.user_id, first_visit }
			axios
				.get(`/erp/v1/manufactures/users/${this.user_id} `, {
					params,
					headers,
				})
				.then((res) => {
					this.order_individual_infos = res.data.order_individual_infos
					if (first_visit) {
						this.user_id = res.data.user_id
						this.users = res.data.users
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setUserId(e) {
			this.user_id = e
			this.fetchOrderIndividualInfos(false)
		},
		processStatus(item) {
			// TODO: 製造部との打ち合わせ後に仕様を確定する
		},
		openSelectDialog(item) {
			this.check_sheets = item.check_sheets
			this.order_individual_info_id = item.id
			if (this.check_sheets.length > 1 || this.check_sheets.length == 0) {
				this.dialog = true
			} else if (this.check_sheets.length == 1) {
				this.openOrderIndividualInfoPage(item.check_sheets[0].id)
			}
		},
		openOrderIndividualInfoPage(check_sheet_id) {
			this.$router.push({
				path: `/manufactures/order_individual_infos/${this.order_individual_info_id}`,
				query: { check_sheet_id: check_sheet_id },
			})
		},
	},
}
</script>
